

export function opener_setupStructure(selfInstance){
  var o = selfInstance.initOptions;


  var str_openerItemStructure = '<div class="' + String(o.opener) + '-wrap real-opener-wrap" data-opener-children-length="' + selfInstance.$feederObject.children().length + '">';

  if (o.opener === 'opener-list' || o.opener === 'opener-bigoptions') {

    // -- we just need opener-list for search
    if (o.opener === 'opener-list' && selfInstance.$dzsSelectorMain.parent().hasClass('disable-search') === false) {
      str_openerItemStructure += '<input class="search-field"/>';
    }
    str_openerItemStructure += '<div class="' + String(o.opener) + ' real-opener">';
  }
  //console.info(o, o.opener,aux);



  // console.info('_t - ',_t);
  // console.info('selfInstance.$dzsSelectorMain.children() - ',selfInstance.$dzsSelectorMain, selfInstance.$dzsSelectorMain.children());
  for (var i = 0; i < selfInstance.$dzsSelectorMain.children().length; i++) {
    var _c = selfInstance.$dzsSelectorMain.children().eq(i);
    if (_c.prop('selected') === true) {
      selfInstance.selectedIndex = i;
    }
  }


  if (o.opener === 'opener-bigoptions') {
    str_openerItemStructure += '</div>';
  }

  str_openerItemStructure += '</div>';

  // console.log('str_openerItemStructure - ', str_openerItemStructure);


  selfInstance.$dzsSelectorMain.parent().append(str_openerItemStructure);

  opener_determineAreas(selfInstance);


}

export function opener_clearBigOptions(selfInstance){

  if (selfInstance.$openerMain) {
    // console.info('_opener_main - ',_opener_main);
    selfInstance.$openerMain.html('');
  } else {

    // console.warn('reinit() o.opener - ', o.opener);
    opener_determineAreas(selfInstance);
  }

}

function opener_appendBigOptions(selfInstance, feedOptions){


  feedOptions.forEach((feedOption)=>{


    const feedOptionHtml = `<${feedOption.bigOptionHtmlTag} class="bigoption select-option ${feedOption.bigOptionExtraClasses} " ${feedOption.bigOptionExtraAttr}>${feedOption.bigOptionHtml}</${feedOption.bigOptionHtmlTag}>`;

    if (selfInstance.$openerMain) {
      selfInstance.$openerMain.append(feedOptionHtml);


    } else {
      selfInstance.$openerWrap.append(feedOptionHtml);

    }
  })
}

export function opener_setupBigOptions(selfInstance){
  var o = selfInstance.initOptions;

  var str_bigOptionStructure;

  // console.log('selfInstance.$feederObject - ', selfInstance.$feederObject);

  const feedOptions = [];



  /** @var {jQuery} */
  let $feederObject = null;

  if (selfInstance.$feederObject) {
    $feederObject = selfInstance.$feederObject;
  }else{
    $feederObject = selfInstance.$dzsSelectorMain;


    if (selfInstance.nativeInputType === 'checkbox') {
      if (selfInstance.$dzsSelectorMain.children('.dzs-style-me-feeder').length) {
        $feederObject = selfInstance.$dzsSelectorMain.children('.dzs-style-me-feeder').eq(0);
      }
    }
  }




  if ($feederObject) {
    for (var i = 0; i < $feederObject.children().length; i++) {

      //console.log(_t.children().eq(i));


      var str_domTag = 'div';
      const $feedObject = $feederObject.children().eq(i);

      // console.log('$feedObject - ', $feedObject);

      if ($feedObject.get(0).nodeName === 'LABEL') {
        str_domTag = 'label';
      }
      if ($feedObject.get(0).nodeName === 'SECTION') {
        str_domTag = 'section';
      }


      let bigOptionExtraAttr = '';
      let bigOptionHtml = $feedObject.html();
      let bigOptionExtraClasses = $feedObject.attr('class');



      if ($feedObject.hasClass('active-checked')) {
        bigOptionExtraClasses += ' active-checked';
      }


      bigOptionHtml = $feedObject.html();



      if (o.opener === 'opener-radio') {
        bigOptionHtml += '<div class="small-bubble"></div>';
      }


      if ($feedObject.attr('data-term_slug')) {
        bigOptionExtraAttr += ' data-term_slug="' + $feedObject.attr('data-term_slug') + '"'
      }
      if ($feedObject.attr('data-term_id')) {
        bigOptionExtraAttr += ' data-term_id="' + $feedObject.attr('data-term_id') + '"'
      }
      if ($feedObject.attr('data-type')) {
        bigOptionExtraAttr += ' data-type="' + $feedObject.attr('data-type') + '"'
      }

      feedOptions.push({
        bigOptionHtmlTag: str_domTag,
        bigOptionHtml: bigOptionHtml,
        bigOptionExtraAttr,
        bigOptionExtraClasses: bigOptionExtraClasses,
      })


    }
  } else {
    // -- no feeder


  }

  opener_appendBigOptions(selfInstance,feedOptions);



  if ($feederObject.hasClass('dzs-style-me-feeder')) {
    $feederObject.children().remove();
  }

  setTimeout(function () {
    if (selfInstance.$selectInputForm && selfInstance.$selectInputForm.hasClass('do-not-trigger-change-on-reinit') === false) {
      selfInstance.$selectInputForm.trigger('change');
    }
    selfInstance.$wrapperMain.find('.search-field').trigger('keyup');


    if (selfInstance.$openerWrap) {

      var aux = selfInstance.$openerWrap.html();

      // console.info('aux - ',aux);


      if (aux.indexOf('{{starssvg}}') > -1) {
        aux = aux.replace(/{{starssvg}}/g, window.svg_star + window.svg_star + window.svg_star + window.svg_star + window.svg_star)
        selfInstance.$openerWrap.html(aux);
      }


    }


  }, 100);
}
export function opener_determineAreas(selfInstance){
  var o = selfInstance.initOptions;

  if (o.opener === 'opener-bigoptions' || o.opener === 'opener-list') {
    selfInstance.$openerWrap = selfInstance.$wrapperMain.find('.' + o.opener + '-wrap');
    if(selfInstance.$wrapperMain.find('div.' + o.opener + '.real-opener').length){

      selfInstance.$openerMain = selfInstance.$wrapperMain.find('div.' + o.opener + '.real-opener');
    }else{

      selfInstance.$openerMain = selfInstance.$wrapperMain.find('div.' + o.opener + '');
    }

  }


  if (o.opener === 'opener-listbuttons' || o.opener === 'opener-radio') {
    selfInstance.$openerWrap = selfInstance.$wrapperMain.find('.' + o.opener + '-wrap');
    selfInstance.$openerMain = selfInstance.$wrapperMain.find('div.' + o.opener + '-wrap');

  }
}